import api from './api';

const hospitalAdminService = {
    // Dashboard
    getDashboard: async () => {
        const response = await api.get('/hospitaladmin/dashboard');
        return response.data;
    },

    // Reports
    getDoctorReports: async () => {
        const response = await api.get('/hospitaladmin/doctors/report');
        return response.data;
    },

    // Branches
    getBranches: async () => {
        const response = await api.get('/hospitaladmin/branches');
        return response.data;
    },

    getBranch: async (id) => {
        const response = await api.get(`/hospitaladmin/branches/${id}`);
        return response.data;
    },

    createBranch: async (data) => {
        const response = await api.post('/hospitaladmin/branches', data);
        return response.data;
    },

    updateBranch: async (id, data) => {
        const response = await api.put(`/hospitaladmin/branches/${id}`, data);
        return response.data;
    },

    deleteBranch: async (id) => {
        const response = await api.delete(`/hospitaladmin/branches/${id}`);
        return response.data;
    },

    // Branch staff (doctor / secretary / lab / pharmacy)
    getBranchStaff: async (branchId, role) => {
        const response = await api.get(`/hospitaladmin/branches/${branchId}/staff`, {
            params: role ? { role } : {}
        });
        return response.data;
    },

    createStaff: async (branchId, data) => {
        const response = await api.post(`/hospitaladmin/branches/${branchId}/staff`, data);
        return response.data;
    },

    updateStaff: async (id, data) => {
        const response = await api.put(`/hospitaladmin/staff/${id}`, data);
        return response.data;
    },

    deleteStaff: async (id) => {
        const response = await api.delete(`/hospitaladmin/staff/${id}`);
        return response.data;
    }
};

export default hospitalAdminService;
